import tippy from "tippy.js";



export default function () {
	return tippy('[data-tippy-content]');
}